import { Filter } from '../types/filter';

/**
 * Strips uuids recursively so two filter trees can be compared structurally
 * (edits regenerate uuids, so raw JSON compare would always differ).
 */
export function normalizeFilter<T extends object>(filter: Filter<T> | null): object | null {
  if (!filter) return null;
  if (filter.type === 'conditions')
    return {
      type: 'conditions',
      operator: filter.operator,
      filters: filter.filters.map((o) => normalizeFilter(o)),
    };
  const { uuid, ...rest } = filter as Filter<T> & { uuid: string };
  return rest;
}
